import React from 'react';
import { commitments, clinicians } from '../../data/site';
import { SectionHeading } from '../ui/SectionHeading';
export function Commitments() {
  return <section className="bg-cream" aria-labelledby="commitments-heading" data-id="element-130" data-mp="1dh1i77xf4wvq">
      <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-28" data-id="element-131" data-mp="1re6kqxxxbdm8">
        <div className="grid gap-14 lg:grid-cols-[1.05fr_0.95fr] lg:gap-20" data-id="element-132" data-mp="1mfdjq4ztpf2y">
          <div data-id="element-133" data-mp="yprizd3syrsu">
            <SectionHeading eyebrow="What we won’t do" title="The commitments, stated as commitments." intro="Every one of these costs us conversions. That is roughly the point." data-id="element-134" data-mp="yp9g3xmmxfby" />
            <ul className="mt-12" data-id="element-135" data-mp="18hf8v9kpo0s7">
              {commitments.map(item => <li key={item.title} className="rule py-7" data-id="element-136" data-mp="13oc9gkt95x43">
                  <h3 className="font-serif text-2xl leading-snug text-ink" data-id="element-137" data-mp="fz9trii6iec8">{item.title}</h3>
                  <p className="mt-3 max-w-2xl leading-relaxed text-ink-soft" data-id="element-138" data-mp="b0gepln8uf9y">{item.detail}</p>
                </li>)}
            </ul>
          </div>

          <div className="rounded-brand border border-ink/15 bg-cream-light p-8 md:p-10" data-id="element-139" data-mp="80dh7w6vxjab">
            <p className="text-[0.6875rem] uppercase tracking-label text-brick" data-id="element-140" data-mp="cy5jnk55onsr">
              Who you’ll actually see
            </p>
            <h3 className="mt-4 font-serif text-3xl leading-tight text-ink" data-id="element-141" data-mp="hst2b2dhanzf">
              Trained in this specifically — not in an afternoon of it.
            </h3>
            <p className="mt-5 leading-relaxed text-ink-soft" data-id="element-142" data-mp="3l8qd9djgrzyt">
              Menopause Society certification means a clinician sat a dedicated examination in this
              field. Most medical degrees devote a matter of hours to it across the entire
              programme, which is the root of almost everything on this page.
            </p>
            <ul className="mt-9" data-id="element-143" data-mp="1afe0omsdg0ch">
              {clinicians.map(clinician => <li key={clinician.name} className="rule py-5 first:border-t-0 first:pt-0" data-id="element-144" data-mp="1ahgsncd343ju">
                  <p className="font-serif text-xl text-ink" data-id="element-145" data-mp="1eik4zovxbhgb">{clinician.name}</p>
                  <p className="mt-1 text-sm text-brick" data-id="element-146" data-mp="3bfioflmj450f">{clinician.role}</p>
                  <p className="mt-2 text-[0.9375rem] leading-relaxed text-ink-soft" data-id="element-147" data-mp="36hh30u1mrtls">
                    {clinician.detail}
                  </p>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}